export default {
  manage_location: "Locations",
  manage_locationsTable_activated: "Activated",
  manage_locationsTable_deactivated: "Deactivated",
  manage_locationsTable_locationsTitle: "Vehicle Location",
  manage_locationsTable_address: "Address",
  manage_locationsTable_enabledELDRule: "ELD 150 Miles Rule",
  manage_locationsTable_timezone: "Time zone",
  manage_locationsTable_unitsCount: "Units",
  manage_locationsTable_search_by_vehicle_location: "Search by Vehicle Location"
};
